module.exports = __webpack_public_path__ + "static/media/Safe-T6.d277a8ad.JPG";